import React, { forwardRef, useImperativeHandle } from 'react';
import { useField, FieldAttributes } from 'formik';
import { Box as Wrapper, Text } from '@tonic-ui/react';
import ReCAPTCHA from 'react-google-recaptcha';

import { InlineError } from './index';

export type RecaptchaRef = {
  resetRecaptcha: () => void;
};
type RecaptchaProps = {
  theme: string;
  siteKey: string;
  locale: string;
} & FieldAttributes<Record<string, unknown>>;

const Recaptcha = forwardRef<RecaptchaRef, RecaptchaProps>(
  ({ theme = 'light', siteKey, locale = 'en', ...rest }, ref) => {
    const [field, meta, helpers] = useField(rest);
    const isInvalid = meta.error && meta.touched ? meta.error : '';
    const { setValue } = helpers;
    const verifyCallback = (response) => {
      setValue(response);
    };

    // React Recaptcha instance
    let recaptchaInstance;
    const resetRecaptcha = () => {
      recaptchaInstance.reset();
    };

    useImperativeHandle(ref, () => ({
      resetRecaptcha,
    }));

    return (
      <Wrapper>
        <ReCAPTCHA
          ref={(e) => (recaptchaInstance = e)}
          sitekey={siteKey}
          render="explicit"
          onChange={(res) => verifyCallback(res)}
          theme={theme}
          hl={locale}
        />
        {isInvalid && (
          <Text size="xs" mt="1x">
            <InlineError errorName={isInvalid} />
          </Text>
        )}
      </Wrapper>
    );
  }
);

Recaptcha.displayName = 'RegistrationRecaptcha';

export default Recaptcha;
